import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';

export const TEAM_INBOX_GATE = 'team_inbox';
export const TEAM_INBOX_PERMISSION = 'inbox.team';

export default class CanSeeTeamInboxHelper extends Helper {
  @service session!: Services['session'];
  @service featureFlags!: Services['feature-flags'];

  compute(): boolean {
    return (
      this.featureFlags.gate.enabled(TEAM_INBOX_GATE) &&
      (this.session.currentUser?.hasAccessTo(TEAM_INBOX_PERMISSION) ?? false)
    );
  }
}
